<template>
<div class="chapter">
<div class="inner_page">
<div id="sec-5">
<p class="center" id="pz5-1" style="margin-top: 13em; line-height: 1.6em;">
<i>I dedicate this book to my parents,<br/>
					Gene and Fayrene Catterton,<br/>
					with love and appreciation for their<br/>
					prayers, perseverance, and faithfulness.</i></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?6fdd9ae6